import React, { useState, useContext, useEffect } from "react";
import { useFmagicMenu } from "./hooks/useFmagicMenu";
import styles from "./style/FmagicMenu.module.scss";
import classNames from "classnames";
import { XIcon } from "@heroicons/react/outline";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import VectorIcons from "../VectorIcons/VectorIcons";
import { QrCode, ScanSharp } from "react-ionicons";

const FmagicMenu = (props) => {
  const { pathname } = useContext(AuthContext);
  const Menus = [
    {
      name: "Compartir",
      icon: "arrow-up-circle-outline",
      dis: "translate-x-0",
      href: "/ShareFiadoScreen",
    },
    {
      name: "Solicitar",
      icon: "arrow-down-circle-outline",
      dis: "translate-x-16",
      href: "/ApplyForScreen",
    },
    { name: "Home", icon: "home-outline", dis: "translate-x-32", href: "/" },

    {
      name: "Movimientos",
      icon: "reader-outline",
      dis: "translate-x-48",
      href: "/MovementScreen",
    },
    { name: "Menú", icon: "list", dis: "translate-x-64", href: "" },
  ];
  const [active, setActive] = useState(0);

  const pathnameMenuActive = [
    "/MenuKycScreen",
    "/ProfileOptionsScreen",
    "/BasicInformationScreen",
    "/AddressScreen",
    "/CreateAddressScreen",
    "/EmailScreen",
    "/CreateEmailScreen",
    "/PhoneScreen",
    "/CreatePhoneScreen",
    "/CardsScreen",
    "/CardDetailScreen",
    "/CreateCardScreen",
    "/BankScreen",
    "/CreateBankScreen",
    "/BankDetailScreen",
    "/LegalNotices",
    "/ConfigScreen",
    "/ChangePasswordScreen",
  ];

  useEffect(() => {
    const menus = Menus.map((munu) => munu.href);
    const indexMenu = menus.indexOf(pathname);

    setActive(
      indexMenu == -1
        ? pathnameMenuActive.filter((href) => href == pathname).length > 0
          ? 4
          : 999
        : indexMenu
    );
  }, [pathname]);

  const route = useNavigate();

  return (
    <>

      <div className="w-screen h-24 flex justify-center items-end sm:pl-52 rounded-lg fixed bottom-0 z-50">
        <div className="border-0 grid justify-end mb-[90px] mr-[-75vw] sm:mb-[10px] sm:mr-[-60vw] md:mr-[-70vw] xl:mr-[-80vw] absolute">
          {
            pathname == "/" ? (
              <div className="p-[20px] bg-[#F02A4B] rounded-full cursor-pointer" onClick={() => route("/PersonalQrScreen")}>
                <QrCode
                  color={"#FFF"}
                />
              </div>
            ) : null
          }
          {
            pathname == "/ShareFiadoScreen" ? (
              <>
                <div className="p-[20px] bg-[#F02A4B] rounded-full cursor-pointer" onClick={() => route("/ReadQrSendFiadoScreen")}>
                  <ScanSharp
                    color={"#FFF"}
                  />
                </div>
                Leer QR
              </>
            ) : null
          }
          {
            pathname == "/ApplyForScreen" ? (
              <>
                <div className="p-[20px] bg-[#F02A4B] rounded-full cursor-pointer" onClick={() => route("/ApplyForQrFormScreen")}>
                  <QrCode
                    color={"#FFF"}
                  />
                </div>
                Crear QR
              </>

            ) : null
          }

        </div>

        <div className="bg-white max-h-[4.7rem] rounded flex w-screen sm:w-96 justify-center  border-4 border-t-4 border-white sm:shadow-2xl ">
          <ul className="flex relative">
            <span
              className={`duration-500 ${active == 4 ? "md:hidden" : ""} ${Menus.length <= active
                ? "bg-transparent "
                : (active == 2
                  ? "bg-transparent !border-transparent "
                  : "bg-primary ") + Menus[active].dis
                } border-4 h-16 border-transparent w-16 absolute 
   -top-5 rounded-full`}
            >
              <span
                className="w-3.5 h-3.5 bg-transparent absolute top-4 -left-[18px] 
    rounded-tr-[11px] shadow-myShadow1"
              ></span>
              <span
                className="w-3.5 h-3.5 bg-transparent absolute top-4 -right-[18px] 
    rounded-tl-[11px] shadow-myShadow2"
              ></span>
            </span>
            {Menus.map((menu, i) => (
              <li
                key={i}
                className={`${menu.name == "Menú" ? "md:hidden" : ""} w-16`}
              >
                <div
                  className={`flex flex-col text-center ${menu.name != "Home" ? "pt-6" : "pt-4"
                    }`}
                  onClick={() => {
                    if (menu.name == "Menú") {
                      props.setSidebarOpen(true);
                    } else {
                      route(menu.href);
                    }
                    setActive(i);
                  }}
                >
                  <span
                    className={`${menu.name != "Home" ? "" : i === active ? "mb-9" : "ml-3"
                      } text-2xl cursor-pointer duration-500 ${i === active && "-mt-6 text-white"
                      }`}
                  >
                    {menu.name != "Home" ? (
                      <ion-icon name={menu.icon}></ion-icon>
                    ) : (
                      <img
                        className={active == 2 ? "h-[60px]" : "h-10"}
                        src={require("../../components/assets/images/adaptive-icon.png")}
                        style={{ position: "absolute" }}
                      />
                    )}
                  </span>
                  <span
                    className={` ${active === i
                      ? "translate-y-4 duration-700 opacity-100"
                      : "opacity-0 translate-y-10"
                      } `}
                  >
                    {menu.name}
                  </span>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>

  );
};

export default FmagicMenu;
